import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <div
      id="contact"
      className="elfsight-app-a6419fec-b66e-4957-ab46-09330d581bb9"
    ></div>
  );
}
